
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Atom";
import Github from "./Github";
import TechStack from "./TechStack";
import AboutDetail from "./AboutDetail";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
        <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src='https://i.postimg.cc/tCPvP840/photo-2022-12-14-15-56-04-new-2.jpg'
             alt="about" className="imgloop" />
          </Col>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
            <strong className="purple"> Littel bit  About Me</strong>
            </h1>
            <AboutDetail />
          </Col>

        </Row>
        <h1 className="project-heading">
          Skills <strong className="purple">Abilities </strong>
        </h1>
        <TechStack />

        <Github />
        {/* <Col md={4} className="project-card">
            <GitStacks
             imgPath={"https://i.postimg.cc/Lsw-26V2K/nbs.png"}
             
            />
          </Col> */}
 </Container>
    </Container>
  );
}

export default About;

